import Vue from 'vue';
import Vuex from 'vuex';
import singleProduct from './singleProduct';
import mediaCenter from './mediaCenter';

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    singleProduct,
    mediaCenter,
  },
});
